import AuthenticationTitleText from "../../texts/authenticationScreen/AuthenticationTitleText";
import AuthenticationSubtitleText from "../../texts/authenticationScreen/AuthenticationSubtitleText";
import AuthenticationIdInput from "../../inputs/authenticationScreen/AuthenticationIdInput";
import AuthenticationPasswordInput from "../../inputs/authenticationScreen/AuthenticationPasswordInput";
import {SystemPrimaryCustomButton} from "../../buttons/SystemCustomButton";
import {isNonEmptyString} from "../../../services/Validator";
import {kButtonStyles} from "../../../constants/styles";
import {CircularProgress} from "@mui/material";
import {kSystemTexts} from "../../../constants/texts";

export default function AuthenticationCard({error, email, onEmailChanged, password, isPasswordVisible, setIsPasswordVisible, onPasswordChanged, isLoading, logUser}) {
    // Used in AuthenticationScreen to display card made of login and
    // password input fields

    // BUILD
    return (
        <div className={"bg-backgroundLight3 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] w-[440px] flex flex-col space-y-[16px] justify-center items-center py-[16px] px-24 mb-[56px] rounded-[16px]"}>
            <div className={"w-full flex flex-col justify-start items-center"}>
                <AuthenticationTitleText />
                <AuthenticationSubtitleText error={error} />
            </div>
            <div className={"w-full flex flex-col space-y-[12px]"}>
                <AuthenticationIdInput email={email}
                                       onEmailChanged={onEmailChanged} />
                <AuthenticationPasswordInput password={password}
                                             isPasswordVisible={isPasswordVisible}
                                             setIsPasswordVisible={setIsPasswordVisible}
                                             onPasswordChanged={onPasswordChanged} />
            </div>
            <SystemPrimaryCustomButton
                label={kSystemTexts.validate}
                extraClass={"mt-[16px]"}
                isDisabled={(!isNonEmptyString(email) || !isNonEmptyString(password))}
                isLoading={isLoading}
                loaderComponent={<CircularProgress size={"24px"}
                                                   style={{'color' : 'white'}} />}
                isFullWidth={true}
                onButtonClick={logUser}
                sizeStyle={kButtonStyles.mediumButtonStyle} />
        </div>
    );
}